import { Component, OnInit } from '@angular/core';
import { IOpsViewerMessagesService } from '../../services/services';
import { ToastMessageOptions } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { IUserManagerService } from '../../services/iUserManager.service';
import { first } from 'rxjs/operators';
import { User } from '../../services/nswag/nswagclient';

@Component({
    selector: 'app-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.css'],
    standalone: false
})
export class RequestComponent implements OnInit {

  user: User = new User();
  userReady = false;
  messages: ToastMessageOptions[] = [];

  fromNewCompanyLayoutButton = false;
  fromCompanyAssociationLayoutButton = false;
  routeCheckReady = false;

  everythingReady = false;

  constructor(
    private _messageService: IOpsViewerMessagesService,
    private _userManagerService : IUserManagerService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.checkIfCameFromRoute();
    this.getAuthenticatedUser();
  }

  checkIfCameFromRoute() {
    this._route.params.subscribe(
      params => {
        const requestType: string = params['requestType'];
        if (requestType && requestType.toLowerCase() === 'newcompany') {
          this.fromNewCompanyLayoutButton = true;
        } else if (requestType && requestType.toLowerCase() === 'companyassociation') {
          this.fromCompanyAssociationLayoutButton = true;
        }
      });
    this.routeCheckReady = true;
    this.checkIfEverythingReady();
  }



  getAuthenticatedUser() {

    this._userManagerService.getCurrentUser().subscribe(u=>{
      this.user = u;
      this.userReady = true;
      this.checkIfEverythingReady();
    });
  }

  checkIfEverythingReady() {
    this.everythingReady = this.userReady && this.routeCheckReady;
  }

  displayErrors(event: any) {
    this.messages = event;
  }

  handleError(error: any, displayMessage: string) {
    this._messageService.errorMessage(error, displayMessage);
  }

  isUserGlobalAdmin(): boolean {
    if (!this.user) { return false; }
    return this.user.isGlobalAdmin;
  }

  asMessageSeverity(severity: ToastMessageOptions['severity']): 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined {
    return severity as 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined;
  }
}
